import React from 'react'
import { ActionButton } from 'modules/ui/atoms/ActionButton'
import useConfig from 'modules/config/state/use-config'
import useStatus from 'modules/status/state/use-status'
import { StatusType } from 'modules/status/state/status-types'
import LoadingSpinnerComponent from 'modules/ui/atoms/Loading/LoadingSpinner'
import { selectContrastingColor } from '@classy/campaign-page-blocks'
import { PaymentSelectionButtonProps } from './payment-selection-button'

interface PaymentActionButtonProps extends PaymentSelectionButtonProps {
  onClick: () => void | Promise<void>
  children: React.ReactNode
  isLoading?: boolean
  color?: string
}

const PaymentActionButton = ({
  onClick,
  children,
  isLoading: customIsLoading,
  color: customColor,
  ...props
}: PaymentActionButtonProps) => {
  const config = useConfig()
  const status = useStatus()

  // Use custom loading state if provided, otherwise fall back to status
  const isLoading =
    customIsLoading ??
    (status.type === StatusType.SUBMITTING || status.type === StatusType.PROCESSING)

  // Use custom color if provided, otherwise fall back to theme primary color
  const buttonColor = customColor ?? config.theme['--theme-color__brand-primary']

  return (
    <ActionButton
      size="lg"
      borderRadius="12px"
      color={buttonColor}
      onClick={onClick}
      disabled={isLoading}
      {...props}
    >
      {isLoading ? (
        <LoadingSpinnerComponent size="sm" color={selectContrastingColor(buttonColor)} />
      ) : (
        children
      )}
    </ActionButton>
  )
}

export default PaymentActionButton
